import { Organization, Owner } from "./ControlPanel";
import { AccessLevel } from "./generics";

export interface RagConfigs {
  description: string;
  configs: LlmConfig[];
}

export interface Rag {
  id: string;
  name: string;
  description: string;
  tags: string[];
  loaders?: EmbeddedLoader[];
  context?: any;
  chats?: any[];
  accessLevel: AccessLevel;
  createDateTime: string;
  owner: Owner;
  organization: Organization;
}
export type RagListDTO = Exclude<Rag, "loaders">;

export interface LoaderMetadata {
  class: string;
  name: string;
  description?: string;
  config: LlmConfig[];
}

export type MetaLoaderListDTO = Exclude<LoaderMetadata, "config">;

export class RagLoader {
  id?: number;
  name: string;
  description: string;
  accessLevel: AccessLevel;
  owner?: Owner;
  organization?: Organization;
  tags: string[];
  type?: string;
  config?: LlmConfig[];
  createDateTime?: string;

  constructor() {
    this.name = "";
    this.description = "";
    this.accessLevel = AccessLevel.TEAM;
    this.tags = [];
  }
}

export type EmbeddedLoader = RagLoader & {
  jobId: string;
  embedDateTime: string;
  status?: { finished: boolean; progress: number; total: number };
}

export interface LlmConfig {
  name: string;
  default?: any;
  description: string;
  type: string; // 'array' | 'string' | 'boolean' | 'integer' | 'float'
  required?: boolean;
  value?: string | boolean | string[];
}

export interface ChatMessage {
  text: any;
  timestamp: string;
  isUserPrompt?: boolean;
  isAlert?: boolean;
}

export interface InvokeBody {
  context: ChatContext;
  input: { question: string };
  thread_id: string;
}

export interface ChatContext {
  project_id: string;
  embeddings_model_name: string;
  llm_model_name: string;
  chroma_persist_directory: string;
  openai_api_base: string;
  openai_api_key: string;
  k: number;
  temperature: number;
  embeddings_temperature: number;
}